import { useState, useEffect } from 'react'
//import 'cb-message-builder/dist/index.css'
import React from 'react'
import { MessageBuilderApp } from 'example-message-builder'
import { AppAssetIndex , AppAssetCatalog, catalogIndexLoader, catalogDetailLoader } from 'example-asset-catalog'
import { App as MessagePreviewsApp } from 'example-message-preview'
import 'example-asset-catalog/dist/export.css'
import 'example-message-preview/dist/export.css'
import 'example-message-builder/dist/export.css'

import {
  createBrowserRouter,
  RouterProvider,
  NavLink,
  Outlet,
  useLoaderData,
  useParams,
  Link
} from "react-router-dom";

let router = createBrowserRouter([
    {
        element: <AppLayout />,
        children: [
          {
            path: "/",
            Component: MessageBuilderApp,
          },
          {
            path: "/asset-catalog",
            Component: AppAssetIndexLoader,
            loader: catalogIndexLoader
           },
           {
            path: "/asset-catalog/:institutionid",
            Component: AppAssetCatalogLoader,
            loader: catalogDetailLoader
           },
           {
            path: "/previews",
            Component: MessagePreviewsApp
           }
        ],
      },
]);


function AppAssetIndexLoader() {
    const institutions = useLoaderData()
    return <AppAssetIndex institutions={institutions} LinkComponent={Link}/>
}

function AppAssetCatalogLoader() {
    const catalogAssets = useLoaderData()
    const { institutionid } = useParams();

    return <AppAssetCatalog catalogAssets={catalogAssets} institutionid={institutionid}/>
}

function App() {
    return (
        <RouterProvider router={router}/>
    )
}

function AppLayout() {
    return (
        <div>
            <AppHeader/>
            <Outlet/>
        </div>
    )
}

function AppHeader() {
    return (
        <div className="app-nav-header">
            <HeaderLink url="/" title="Content Builder"/>
            <HeaderLink url="/asset-catalog" title="Asset Catalog"/>
            <HeaderLink url="/previews" title="Previews"/>
        </div>
    )
}

function HeaderLink({ title, url }) {
    let isSelected = true
    return <NavLink  to={url}>{title}</NavLink>
}

export default App
